module.exports = __webpack_public_path__ + "img/fauno.338adb4d.jpg";